import React, { useState } from 'react';
import Input from 'react-phone-number-input/input';
import 'react-phone-number-input/style.css';
import axios from 'axios';
import { message, Spin } from 'antd';

const success = () => {
  message.success({
    content: 'Message is sent successfully',
    className: 'message_notif',
    style: {
      marginTop: '80px',
    },
  });
};
const error = () => {
  message.error({
    content: 'Unable to send message, please try again',
    className: 'message_notif',
    style: {
      marginTop: '80px',
    },
  });
};
const errorEmpty = () => {
  message.error({
    content: 'Please fill out the empty field',
    className: 'message_notif',
    style: {
      marginTop: '80px',
    },
  });
};

function ContactForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [phoneValue, setPhoneValue] = useState('');

  const initFormData = {
    fullname: '',
    companyname: '',
    email: '',
    message: '',
  };

  const [formData, setFormData] = useState(initFormData);
  const { fullname, email, companyname, message } = formData;
  // console.log('finalForm', formData);

  const handleOnChange = (e) => {
    let name = document.getElementById('name').value;
    let email = document.getElementById('email').value;
    let companyname = document.getElementById('companyname').value;
    let message = document.getElementById('message').value;

    if (name.includes('  ')) {
      const name = document.getElementById('name');
      name.value = name.value.substring(0, e.target.selectionStart - 1);
    } else if (companyname.includes('  ')) {
      const companyname = document.getElementById('companyname');
      companyname.value = companyname.value.substring(
        0,
        e.target.selectionStart - 1
      );
    } else if (message.includes('  ')) {
      const message = document.getElementById('message');
      message.value = message.value.substring(0, e.target.selectionStart - 1);
    }

    name.trim();
    email.trim();
    companyname.trim();
    message.trim();

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      phonenumber: phoneValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitted(true);
    const phoneInput = {
      phonenumber: phoneValue,
    };
    setFormData({ ...formData, ...phoneInput });

    if (
      formData.message === ' ' ||
      formData.fullname === ' ' ||
      formData.companyname === ' '
    ) {
      formData.message = '';
      errorEmpty();
      setIsSubmitted(false);
    } else {
      //axios
      const config = {
        header: {
          'Content-Type': 'application/json',
        },
      };
      const res = await axios.post(
        // 'https://api.sqreemtech-dev.com/sqreemwebsite/sendemail',
        'https://api-3.sqreemtech.com/sqreemwebsite/sendemail',

        {
          _class: 'SqreemWebsite',
          _function: 'SendEmail',
          _account: 'sqreem',
          _username: 'qrm_jek',
          _data: formData,
        },
        config
      );

      if (res.data.success === 'True') {
        // if (res) {
        setTimeout(() => {
          success();
        }, 500);
      } else {
        setTimeout(() => {
          error();
        }, 500);
      }
      setFormData(initFormData);
      setPhoneValue('');

      setIsSubmitted(false);
    }
  };

  return (
    <>
      {isSubmitted ? (
        <div className='loading_contact d-flex align-items-center justify-content-center'>
          <Spin size='large' tip='Sending...' />
        </div>
      ) : null}

      <form
        onSubmit={(e) => handleSubmit(e)}
        id='contactForm'
        className='contact_form_main d-flex-col gap-1'
      >
        <div className='d-flex gap-1 justify-content-around'>
          <input
            required
            title='Alphabets Only'
            pattern='[a-zA-Z\s]*'
            autoComplete='none'
            id='name'
            type='text'
            name='fullname'
            value={fullname}
            onChange={(e) => handleOnChange(e)}
            placeholder='Full Name'
          />
          <input
            required
            title='Invalid Email'
            pattern='(^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$)'
            autoComplete='none'
            id='email'
            type='text'
            name='email'
            value={email}
            onChange={(e) => handleOnChange(e)}
            placeholder='Email'
          />
        </div>
        <div className='d-flex gap-1 justify-content-around'>
          <input
            required
            title='Invalid Input'
            pattern='[a-zA-Z0-9\s]*'
            autoComplete='none'
            id='companyname'
            type='text'
            name='companyname'
            value={companyname}
            onChange={(e) => handleOnChange(e)}
            placeholder='Company'
          />
          <div className='react_phone'>
            <Input
              required
              autoComplete='none'
              id='phone'
              placeholder='Enter phone number'
              value={phoneValue}
              onChange={setPhoneValue}
            />
          </div>
        </div>
        <textarea
          required
          className='form-control-message'
          id='message'
          type='text'
          name='message'
          value={message}
          onChange={(e) => handleOnChange(e)}
          placeholder='Message'
        />
        <button name='requestDemo'>Request demo</button>
      </form>
    </>
  );
}

export default ContactForm;
